import { useCandidateRedux } from "#candidate/redux/slice"
import LabelValue from "#core/components/label/LabelValue"
import { useVacanteRedux } from "#vacancy/redux/slice"
import { Box, Grid, TextField } from "@mui/material"

export const EvaluationHeaderDefaultValues = {
	valid_license: "",
	commute_time: "",
	salary_expectation: "",
	other_deductions: "",
}

export const EvaluationHeader = ({
	values = EvaluationHeaderDefaultValues,
	setValues,
	interviewRh,
}) => {
	const { candidate } = useCandidateRedux()
	const { vacancy } = useVacanteRedux()
	const items = [
		{ name: "valid_license", label: "Licencia Vigente", grid: { xs: 12, sm: 6, md: 4 } },
		{ name: "commute_time", label: "Tiempo de Traslado", grid: { xs: 12, sm: 6, md: 4 } },
		{
			name: "salary_expectation",
			label: "Expectativa Económica",
			grid: { xs: 12, sm: 6, md: 4 },
		},
		{
			name: "other_deductions",
			label: "Otros Descuentos",
			grid: { xs: 12 },
		},
	]

	const ItemsInput = items.map((item) => {
		const handleChange = (e) => {
			setValues((values) => ({
				...values,
				[item.name]: e.target.value,
			}))
		}
		return (
			<Grid item {...item.grid}>
				<TextField
					label={item.label}
					onChange={handleChange}
					value={values[item?.name] || ""}
					fullWidth
				/>
			</Grid>
		)
	})

	return (
		<Box p={2}>
			{/* Stats Cards */}
			<Grid container spacing={2} sx={{ mb: 4 }}>
				<Grid item xs={12} sm={6} md={3}>
					<LabelValue label="Nombre del Candidato" value={candidate.full_name} />
				</Grid>
				<Grid item xs={12} sm={6} md={3}>
					<LabelValue label="Puesto" value={vacancy.perfil_puesto_name} />
				</Grid>
				<Grid item xs={12} sm={6} md={3}>
					<LabelValue label="Departamento" value={vacancy.departamento_name} />
				</Grid>

				<Grid item xs={12} sm={6} md={3}>
					<LabelValue label="Reclutador" value={vacancy.reclutador_name} />
				</Grid>
				<Grid item xs={12} sm={6} md={3}>
					<LabelValue label="Sucursal" value={vacancy.sucursal_name} />
				</Grid>
				<Grid item xs={12} sm={6} md={3}>
					<LabelValue label="Jefe Inmediato" value={vacancy.jefe_directo_name} />
				</Grid>
			</Grid>

			{interviewRh && (
				<Grid container spacing={2} sx={{ mb: 4 }}>
					{ItemsInput}
				</Grid>
			)}
		</Box>
	)
}
